import { Icon } from '@iconify/react';
import { useState } from 'react';

const JobCard = ({ job, onClick }) => {
  const [isBookmarked, setIsBookmarked] = useState(false);

  const handleBookmark = (e) => {
    e.stopPropagation();
    setIsBookmarked(!isBookmarked);
  };

  return (
    <div
      className="job-card bg-white rounded-2xl border border-gray-100 p-5 md:p-6 transition-all duration-300 cursor-pointer hover:shadow-md"
      onClick={() => onClick && onClick(job)}
    >
      <div className="flex items-start gap-4">
        {/* Company Logo */}
        <img
          src={`https://picsum.photos/${job.logo}.jpg`}
          className="w-11 h-11 rounded-xl object-cover flex-shrink-0 border border-gray-100"
          alt={job.company}
          onError={(e) => {
            e.target.src = 'https://picsum.photos/seed/default/40/40.jpg';
          }}
        />

        <div className="flex-1 min-w-0">
          {/* Job Header */}
          <div className="flex items-start justify-between gap-3 mb-1">
            <div>
              <h3 className="text-base font-semibold text-gray-900 hover:text-zentra-600 transition-colors line-clamp-1">
                {job.title}
              </h3>
              <p className="text-sm text-gray-500">{job.company}</p>
            </div>

            {/* Bookmark Button */}
            <button
              className="flex-shrink-0 w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center hover:bg-zentra-50 hover:border-zentra-300 transition-all group"
              onClick={handleBookmark}
              aria-label={isBookmarked ? 'Remove bookmark' : 'Add bookmark'}
            >
              <Icon
                icon={isBookmarked ? 'mdi:bookmark' : 'mdi:bookmark-outline'}
                className={`text-base transition-colors ${
                  isBookmarked ? 'text-zentra-500' : 'text-gray-400 group-hover:text-zentra-500'
                }`}
              />
            </button>
          </div>

          {/* Job Details */}
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5 mt-2.5 mb-3">
            <span className="text-xs text-gray-500 flex items-center gap-1">
              <Icon icon="mdi:map-marker-outline" className="text-sm" />
              {job.location}
            </span>
            <span className="text-xs text-gray-500 flex items-center gap-1">
              <Icon icon="mdi:clock-outline" className="text-sm" />
              {job.type}
            </span>
            <span className="text-xs text-gray-500 flex items-center gap-1">
              <Icon icon="mdi:chart-line" className="text-sm" />
              {job.experience}
            </span>
            <span className="text-xs font-medium text-emerald-600 flex items-center gap-1">
              <Icon icon="mdi:cash" className="text-sm" />
              {job.salary}
            </span>
          </div>

          {/* Tags */}
          <div className="flex flex-wrap items-center gap-2 mb-3">
            {job.tags && job.tags.slice(0, 3).map((tag, i) => (
              <span
                key={i}
                className="text-xs bg-zentra-50 text-zentra-600 font-medium px-2.5 py-1 rounded-md"
              >
                {tag}
              </span>
            ))}
            {job.tags && job.tags.length > 3 && (
              <span className="text-xs text-gray-400 font-medium px-2 py-1">
                +{job.tags.length - 3}
              </span>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between">
            <span className="text-xs text-gray-400">{job.posted}</span>
            {job.urgent && (
              <span className="text-xs font-medium bg-rose-100 text-rose-600 px-2.5 py-1 rounded-full flex items-center gap-1">
                <Icon icon="mdi:fire" className="text-sm" />
                Urgent
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobCard;
